import AddIcon from '@mui/icons-material/Add';
import { Button, Toolbar } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AddTeamMember from './addTeamMember.component';

const StyledRoot = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1, 0, 3),
}));

export default function TeamListToolbar({ handleRefreshGrid }) {
  const { t: translate } = useTranslation();
  const [openWorkPlaceModal, setWorkPlaceModal] = useState(false);
  const handleWorkPlaceClick = () => {
    setWorkPlaceModal(true);
  };
  const handleClose = () => {
    setWorkPlaceModal(false);
  };
  const handleSuccess = () => {
   // handleRefreshGrid(true);
    setWorkPlaceModal(false);
  };

  return (
    <>
      <StyledRoot>
        <Button variant="contained" startIcon={<AddIcon />} onClick={handleWorkPlaceClick}>
        {translate('manage_brand.manage_users.add_team_member')}
        </Button>
      </StyledRoot>
      {openWorkPlaceModal && <AddTeamMember handleClose={handleClose} handleSuccess={handleSuccess} />}
    </>
  );
}
